import { useState } from "react";
import { updateDataSourceSchedule } from "../../../../api/dataSourceScheduleApi";

export function useOverlaySourceSchedule({ domain, onRefresh, showToast, onScheduleSaved }) {
  const [scheduleSource, setScheduleSource] = useState(null);
  const [scheduleSaving, setScheduleSaving] = useState(false);

  const handleSaveSchedule = async (source, payload) => {
    const sourceKey = source.sourceKey || source.sourceCode;
    setScheduleSaving(true);
    try {
      const schedule = await updateDataSourceSchedule(domain, sourceKey, payload);
      onScheduleSaved?.(source, schedule);
      setScheduleSource(null);
      showToast?.(`Schedule updated for ${source.displayName || source.sourceName}.`, "success");
      onRefresh?.({ silent: true });
    } catch (error) {
      showToast?.(error.message || "Unable to save schedule.", "error");
      throw error;
    } finally {
      setScheduleSaving(false);
    }
  };

  return {
    scheduleSource,
    setScheduleSource,
    scheduleSaving,
    handleSaveSchedule,
  };
}
